// Copyright (c) StrangeBee 2023

import { classList } from '@Helpers/className';
import { Input, InputProps } from 'antd';
import React, { ReactElement } from 'react';

import './THPassword.scss';

interface THPasswordProps extends InputProps {
    borderless?: boolean;
    errorless?: boolean;
}

export const THPassword = ({
    borderless = false,
    errorless = false,
    className,
    autoComplete,
    ...props
}: THPasswordProps): ReactElement => (
    <Input.Password
        className={classList('th-password', className, { 'no-border': borderless, 'no-error': errorless })}
        size="large"
        {...props}
        autoComplete={autoComplete || 'off'}
    />
);
